// import NotificationsIndex from './views/Notifications/Index.vue'
// import BarcodeScan from './views/OrderRescue/BarcodeScan.vue'
// import HoldReasonsReview from './views/OrderDetail/HoldReasonsReview'
// import LocationProperties from './views/Locations/LocationProperties'
import OrderPickByStoreScan from './views/OrderDetail/Scan.vue'
import OrderDetailLayout from "./views/OrderDetail/Layout"
import OrderDetailOverview from "./views/OrderDetail/Overview"
import OrderDetailSalesOrderLines from "./views/OrderDetail/SalesOrderLines"
import OrderDetailHoldReasons from "./views/OrderDetail/HoldReasonsReview"
import OrderDetailDispatchStatus from "./views/OrderDetail/DispatchStatus"
import OrderDetailHistory from "./views/OrderDetail/History"

import Homepage from "./views/Homepage"
import Dashboard from "./views/Dashboard"
import ImportErrors from "./views/ImportErrors"
import Refunds from "./views/OrderDetail/Refunds";
import ProcessStart from "./views/ProductProcessing/Start.vue";

import ShipmentBatchesIndex from "./views/ShipmentBatching/ShipmentBatchesIndex.vue";
import ShipmentBatchView    from "./views/Locations/ShipmentBatchView.vue";
import ShipmentBatchCreate  from "./views/ShipmentBatching/ShipmentBatchCreate.vue";

import EditLayout from "./views/Locations/EditLayout";
import LocationIndex from "./views/Locations/Index"
import EditContactInfo from "./views/Locations/EditContactInfo";
import EditServiceTimesLayout from "./views/Locations/EditServiceTimesLayout";
import EditLocationProperties from "./views/Locations/EditLocationProperties";
import EditLocationServices from "./views/Locations/EditLocationServices";

import HoldRuleGroups from "./views/HoldRuleGroups"
import HoldRuleGroup from "./views/HoldRuleGroups/Group.vue"
import HoldRuleGroupView from "./views/HoldRuleGroups/GroupView.vue"
import HoldRuleGroupEdit from "./views/HoldRuleGroups/GroupEdit.vue"
import HoldRuleGroupDelete from "./views/HoldRuleGroups/GroupDelete.vue"

import GoodReceiptIndex   from "./views/Locations/GoodsReceipts/GoodsReceiptsIndex.vue";
import GoodsReceiptCreate from "./views/Locations/GoodsReceipts/GoodsReceiptCreate.vue";
import GoodsReceiptView   from "./views/Locations/GoodsReceipts/GoodsReceiptView.vue";

import AppSettings from "./views/Locations/AppSettings.vue";

import Settings                from "./views/Settings/Index.vue"

import Presales from "./views/Presales"
import PresaleList from "./views/Presales/PresaleList"
import PresaleDetail from "./views/Presales/PresaleDetail"
import PresaleStoreLabels from "./views/Presales/PresaleStoreLabels"

import { PRODUCT_PROCESS_TYPE_RETURN, PRODUCT_PROCESS_TYPE_SORT } from "./data/productProcessType";
import ProcessReturn from "./views/ProductProcessing/ProcessReturn.vue";
import ShowIcons from "./views/ShowIcons.vue";
import SleProductsAdmin from "./views/SleAdmin/SleProductsAdmin.vue";
import FrontendFilters from "./components/FrontendFilters/FrontendFilters.vue";
import {FrontendFiltersOrderSearch} from "./views/OrderSearch/FrontendFiltersOrderSearch.ts";
import TestPdfDownload from "@/views/TestPdfDownload.vue";
import SleSupplyChainIndex from "@/views/SleAdmin/SleSupplyChainIndex.vue";
import {FrontendFiltersPickByStoreSearch} from "@/views/OrderSearch/FrontendFiltersPickByStoreSearch";
import Pickup from "@/views/OrderDetail/Pickup.vue";
import PackageManagement from "@/views/Locations/PackageManagement.vue";
import {FrontendFiltersRequiresNextActionDecisionSearch} from "@/views/OrderSearch/FrontendFiltersRequiresNextActionDecisionSearch";
import NextActionDecision from "@/views/OrderDetail/NextActionDecision.vue";
import {FrontendFiltersLocationSearch} from "@/views/Locations/FrontendFiltersLocationSearch";
import FrontendFiltersOrderEventSearch from "@/views/OrderDetail/FrontendFiltersOrderEventSearch";
import SalesOrderFileImport from "@/views/Locations/SalesOrderFileImport.vue";
import {FrontendFiltersTriggers} from "@/views/Triggers/FrontendFiltersTriggers";
import SleQuickSuggestion from "@/views/SleAdmin/SleQuickSuggestion.vue";

// Note: as defined in ./bootstrap.ts, all these routes start with /web/*
export default [
    {path: '/orders/search', name: 'FrontendFilterOrderSearch', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersOrderSearch,
        presetIdentifier: 'default',
    }},
    {path: '/orders/hold-order-search', name: 'FrontendFilterOrderSearchHoldOrders', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersOrderSearch,
        presetIdentifier: 'hold_orders',
    }},
    {path: '/orders/return-order-search', name: 'FrontendFilterOrderSearchReturnOrders', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersOrderSearch,
        presetIdentifier: 'return_orders',
    }},
    {path: '/orders/fallback-order-search', name: 'FrontendFilterOrderSearchFallbackOrders', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersOrderSearch,
        presetIdentifier: 'fallback_orders',
    }},
    {path: '/orders/refund-order-search', name: 'FrontendFilterOrderSearchRefundOrders', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersOrderSearch,
        presetIdentifier: 'refund_orders',
    }},
    {path: '/orders/pick-by-store-search', name: 'FrontendFilterOrderSearchPickByStore', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersPickByStoreSearch,
        presetIdentifier: 'default',
    }},
    {path: '/orders/next-action-decision-search', name: 'FrontendFilterOrderSearchRequiresNextActionDecision', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersRequiresNextActionDecisionSearch,
        presetIdentifier: 'default',
    }},
    {path: '/location-search', name: 'FrontendFilterLocationSearch', component: FrontendFilters, props: {
        presetIdentifier: 'default',
        filterGroup: new FrontendFiltersLocationSearch,
    }},

    {path: '/orders/import-errors', name: 'orderListImportErrors', component: ImportErrors},

    // // Provide een route om components die in OS worden aangeroepen dmv een custom tag te kunnen testen.
    // // Zie ./app.ts -> Vue.components voor een lijst van zulke components.
    // {path: '/vue-test', component: HoldReasonsReview, props: {
    //     salesOrderIdentifier: '210609-80344134',
    // }}

    {path: '/', name:'homepage', component: Homepage, props: {}},

    {path: '/dashboard', name:'dashboard', component: Dashboard, props: {}},

    {
        path: '/orders/presales',
        name: 'Presales',
        component: Presales,
        props: true,
        children: [
            {
                path: 'incomplete',
                name: 'PresaleListIncomplete',
                component: PresaleList,
                props: true,
            },

            {
                path: 'future',
                name: 'PresaleListFuture',
                component: PresaleList,
                props: true,
            },

            {
                path: 'active',
                name: 'PresaleListActive',
                component: PresaleList,
                props: true,
            },

            {
                path: 'past',
                name: 'PresaleListHistory',
                component: PresaleList,
                props: true
            },

            {
                path: ':presaleId',
                name: 'PresaleDetail',
                component: PresaleDetail,
                props: true
            },

            {
                path: 'store-labels',
                name: 'PresaleStoreLabels',
                component: PresaleStoreLabels,
                props: true,
            },
        ]
    },

    {path: '/orders/detail/:salesOrderIdentifier', component: OrderDetailLayout, props: true, redirect: '/orders/detail/:salesOrderIdentifier/overview', children: [
        {path: 'overview', component: OrderDetailOverview, name: 'OrderDetailOverview'},
        {path: 'sales-lines', component: OrderDetailSalesOrderLines, name: 'OrderDetailSalesOrderLines'},
        {path: 'dispatch-status', component: OrderDetailDispatchStatus, name: 'OrderDetailDispatchStatus'},
        {path: 'hold-reasons', component: OrderDetailHoldReasons, name: 'OrderDetailHoldReasons'},
        {path: 'pick-by-store/:dispatchRequestId', component: OrderPickByStoreScan, name: 'OrderPickByStoreScan', props: true},
        {path: 'refunds', component: Refunds, name: 'OrderDetailRefunds'},
        {path: 'history', component: OrderDetailHistory, name: 'OrderDetailHistory', props: true},
        {path: 'event-results', name: 'OrderDetailEventResults', component: FrontendFilters, props: {
            filterGroup: new FrontendFiltersOrderEventSearch,
            presetIdentifier: 'default',
        }},
        {path: 'pickup', component: Pickup, name: 'OrderDetailPickup'},
        {path: 'next-action-decision', component: NextActionDecision, name: 'OrderNextActionDecision'},
    ]},


    {path: '/shipment-batches', name: 'ShipmentBatchesIndex', component: ShipmentBatchesIndex},
    {path: '/stock-management/:productIdentifier', name: 'StockManagementWithProduct', component: SleProductsAdmin},
    {path: '/stock-management', name: 'StockManagement', component: SleProductsAdmin},
    {path: '/supply-chains', name: 'SupplyChainManagement', component: SleSupplyChainIndex},
    {path: '/quick-suggestion/:productIdentifier?', name: 'QuickSuggestion', component: SleQuickSuggestion},


    {path: '/locations', name: 'locationIndex', component: LocationIndex},
    {path: '/locations', name: 'LocationLayout', component: EditLayout, children: [
        {path: '/locations/create', name: 'locationCreate', component: EditContactInfo},
        {path: ':locationTypeIdentifier/:locationIdentifier/contact-info', name: 'locationEditContactInfo', component: EditContactInfo},
        {path: ':locationTypeIdentifier/:locationIdentifier/service-times/:serviceTypeIdentifier?', name: 'locationEditServiceTimes', component: EditServiceTimesLayout, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/properties', name: 'EditLocationProperties', component: EditLocationProperties},
        {path: ':locationTypeIdentifier/:locationIdentifier/services', name: 'EditLocationServices', component: EditLocationServices},
        {path: ':locationTypeIdentifier/:locationIdentifier/shipment-batch/create', name: 'ShipmentBatchCreate', component: ShipmentBatchCreate, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/shipment-batch/:batchIdentifier', name: 'ShipmentBatchView', component: ShipmentBatchView, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/goods-receipt', name: 'GoodsReceiptIndex', component: GoodReceiptIndex, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/goods-receipt/create', name: 'GoodsReceiptCreate', component: GoodsReceiptCreate, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/goods-receipt/:goodsReceiptIdentifier', name: 'GoodsReceiptView', component: GoodsReceiptView, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/app-settings', name: 'AppSettings', component: AppSettings, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/package-management', name: 'PackageManagement', component: PackageManagement, props: true},
        {path: ':locationTypeIdentifier/:locationIdentifier/sales-order-file-import', name: 'SalesOrderFileImport', component: SalesOrderFileImport, props: true},
    ]},

    {path: `/product-processing/:locationTypeIdentifier/:locationIdentifier/:batchModelType/:batchModelIdentifier/:processType`, name: 'ProcessStartWithBatch', component: ProcessStart, props: true},
    {path: `/product-processing/:locationTypeIdentifier/:locationIdentifier/:processType`, name: 'ProcessStartWithoutBatch', component: ProcessStart, props: true},


    {
        name: 'settings',
        path: '/settings/:groupIdentifier?',
        component: Settings,
    },

    {
        path: '/hold-rules',
        component: HoldRuleGroups,
        name: 'holdRuleGroups'
    },
    {
        path: '/hold-rules/:groupIdentifier/',
        component: HoldRuleGroup,
        name: 'holdRuleGroup',
        props: true,
        children: [
            {
                path: 'edit',
                component: HoldRuleGroupEdit,
                name: 'holdRuleGroupEdit',
                props: true,
            },
            {
                path: 'view',
                component: HoldRuleGroupView,
                name: 'holdRuleGroupView',
            },
            {
                path: 'delete',
                component: HoldRuleGroupDelete,
                name: 'holdRuleGroupDelete',
            }
        ],
    },

    {path: '/triggers', name: 'Triggers', component: FrontendFilters, props: {
        filterGroup: new FrontendFiltersTriggers,
        presetIdentifier: 'default',
    }},

    {path: `/admin/show-icons`, name: 'ShowIcons', component: ShowIcons},

    {path: `/test-pdf-download`, name: 'TestPdfDownload', component: TestPdfDownload},
]
